export default {"src":"/_next/static/image/public/images/ic_toast_clock.0abbf8b87ea9763bcecb6f565fe40cc6.svg","height":24,"width":24};